export const MODULE_KEYS = {
  LIST: "modules" as const,
};
